export default __webpack_public_path__ + "static/media/SWT1930.34I-41179_-24473_0.32a8ce1b.jpg";